document.addEventListener("click", function(event) {
  const tab = event.target.closest(".product-tab"); // タブがクリックされたかどうか判定
  if (!tab) return; // クリックされた要素がタブでなければ何もしない

  const targetId = tab.getAttribute("data-product-tab");
  const targetContent = document.getElementById(`product-tab-${targetId}`);

  if (!targetContent) return;

  // すべてのタブとコンテンツの active クラスを削除
  document.querySelectorAll(".product-tab").forEach(t => t.classList.remove("active"));
  document.querySelectorAll(".product-tab-content").forEach(c => c.classList.remove("active"));

  // クリックされたタブと対応するコンテンツに active クラスを追加
  tab.classList.add("active");
  targetContent.classList.add("active");
});
